import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5 text-black" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-between flex-wrap items-center col-span-12"
}
const _hoisted_3 = { class: "flex items-center gap-5" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ListHeader = _resolveComponent("ListHeader")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_ListContent = _resolveComponent("ListContent")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_ctx.role)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("objectives.titles.materials")), 1),
            (_ctx.role === 'TEACHER')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: _ctx.$t('objects.add'),
                  class: "btn-outline p-button-sm",
                  icon: "pi pi-plus",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToMaterial(_ctx.objectiveId, { type: 'add' })))
                }, null, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.role === 'TEACHER')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_Button, {
                  label: _ctx.$t('labels.save'),
                  disabled: _ctx.data?.length == 0,
                  loading: _ctx.loading,
                  class: "btn-primary p-button-sm",
                  onClick: _ctx.nextStep
                }, null, 8, ["label", "disabled", "loading", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_InfiniteScroll, { onOnScroll: _ctx.onScroll }, {
      header: _withCtx(() => [
        _createVNode(_component_ListHeader, {
          onOnSelect: _ctx.onFilter,
          onOnSearch: _ctx.onSearch
        }, null, 8, ["onOnSelect", "onOnSearch"])
      ]),
      content: _withCtx(() => [
        (_ctx.loader)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              loader: _ctx.loader,
              loaderSize: "h-full"
            }, null, 8, ["loader"]))
          : (!_ctx.data || _ctx.data.length === 0)
            ? (_openBlock(), _createBlock(_component_EmptyData, {
                key: 1,
                data: _ctx.data?.length === 0,
                title: _ctx.emptyState.title,
                label: _ctx.emptyState.description,
                image: _ctx.emptyState.image,
                imgSize: "h-40"
              }, null, 8, ["data", "title", "label", "image"]))
            : (_openBlock(), _createElementBlock("section", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    id: "content",
                    class: "bg-white",
                    key: index
                  }, [
                    _createVNode(_component_ListContent, {
                      data: item,
                      role: _ctx.role,
                      index: index,
                      allData: _ctx.data,
                      loader: _ctx.loadingDelete,
                      "onUpdate:loader": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loadingDelete) = $event)),
                      onOnEdit: ($event: any) => (
                _ctx.goToMaterial(_ctx.objectiveId, {
                  id: item.id,
                  type: 'edit',
                })
              ),
                      onOnDelete: ($event: any) => (_ctx.deleteMaterial(item.id))
                    }, null, 8, ["data", "role", "index", "allData", "loader", "onOnEdit", "onOnDelete"])
                  ]))
                }), 128))
              ]))
      ]),
      _: 1
    }, 8, ["onOnScroll"])
  ]))
}